import { FunctionComponent } from "react"
import Button from "react-bootstrap/Button"
import Card from "react-bootstrap/Card"
import { useNavigate } from "react-router-dom"

interface ITemplatesCard {}
const TemplatesCard: FunctionComponent<ITemplatesCard> = () => {
	const navigate = useNavigate()
	return (
		<Card>
			<Card.Header>Templates</Card.Header>
			<Card.Body>
				<Card.Text>View, create, and update Router Templates.</Card.Text>
				<Button variant="primary" className="mt-3" onClick={() => navigate("templates")}>
					View Templates
				</Button>
			</Card.Body>
		</Card>
	)
}
export default TemplatesCard
